import { render } from "./SPFileLine.vue?vue&type=template&id=4aeb0c4d"
import script from "./SPFileLine.vue?vue&type=script&lang=js"
export * from "./SPFileLine.vue?vue&type=script&lang=js"
script.render = render

export default script